class FastUTVDynoBooking extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.form = this.closest('form');
    this.experience = this.querySelector('sesami-experience');
    this.status = this.querySelector('[data-dyno-status]');
    this.blocked = false;
    this.submitted = false;
    this.busy = false;
    this.addEventListener('change', () => this.refresh(), { signal });
    this.form.addEventListener('change', () => this.refresh(), { signal });
    this.form.addEventListener('input', () => this.refresh(), { signal });
    for (const name of ['sesami:loaded', 'sesami:reservation:success', 'sesami:reservation:failed']) {
      window.addEventListener(name, (event) => {
        const ownId = this.experience.getAttribute('tag-id');
        if (event.detail?.tagId && ownId && String(event.detail.tagId) !== ownId) return;
        if (name === 'sesami:reservation:failed') {
          this.blocked = true;
          this.status.textContent = this.dataset.failed;
        } else if (name === 'sesami:reservation:success') {
          this.blocked = false;
          this.submitted = false;
          this.status.textContent = '';
        }
        this.refresh();
      }, { signal });
    }
    this.observer = new MutationObserver(() => this.refresh());
    this.observer.observe(this.form, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
    this.refresh();
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
  }
  get selected() {
    return [...this.querySelectorAll('[data-dyno-extra]')].filter(input => input.checked && !input.disabled);
  }
  get reserved() {
    return !this.blocked && !this.submitted && ['[sesami-hidden-date]', '[sesami-hidden-time]', '[sesami-hidden-reservation-token]'].every(selector => this.form.querySelector(selector)?.value?.trim());
  }
  refresh() {
    const cents = Number(this.dataset.price) + this.selected.reduce((sum, input) => sum + Number(input.dataset.price), 0);
    const label = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency }).format(cents / 100);
    const total = this.querySelector('[data-dyno-total]');
    if (total.textContent !== label) total.textContent = label;
    this.form.querySelectorAll('[name="quantity"]').forEach(input => { if (input.value !== '1') input.value = '1'; });
    this.form.querySelectorAll('button[type="submit"], input[type="submit"]').forEach(button => {
      button.disabled = this.busy || !this.reserved;
    });
  }
  validateSubmit() {
    if (this.busy) return false;
    if (!this.reserved) {
      this.status.textContent = this.submitted ? this.dataset.added : this.dataset.selectTime;
      this.experience.scrollIntoView({ block: 'center', behavior: 'instant' });
      this.refresh();
      return false;
    }
    return this.form.reportValidity();
  }
  buildFormData(original) {
    const data = new FormData();
    for (const [key, value] of original.entries()) {
      if (key.startsWith('fastutv-adapter-')) continue;
      if (['id', 'quantity', 'selling_plan'].includes(key) || key.startsWith('properties[')) {
        const nested = key.startsWith('properties[') ? `items[0][properties]${key.slice(10)}` : `items[0][${key}]`;
        data.append(nested, value);
      } else {
        data.append(key, value);
      }
    }
    data.set('items[0][quantity]', '1');
    this.selected.forEach((input, index) => {
      data.set(`items[${index + 1}][id]`, input.value);
      data.set(`items[${index + 1}][quantity]`, '1');
    });
    return data;
  }
  setBusy(value) {
    this.busy = value;
    this.refresh();
  }
  uncertain() {
    this.submitted = true;
    this.status.textContent = this.dataset.requestError;
    this.refresh();
  }
  added() {
    this.submitted = true;
    this.status.textContent = this.dataset.added;
    this.refresh();
  }
}
if (!customElements.get('fastutv-dyno-booking')) customElements.define('fastutv-dyno-booking', FastUTVDynoBooking);
